import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de Roles y Funciones
 * - Rol actual, aplicar a agente, link a perfil de agente
 * - Extensible para gestiÃ³n de roles y permisos
 */
export default function RolesSection() {
    return (
        <Box>
            <Typography variant="h6">Roles y Funciones</Typography>
            {/* TODO: Mostrar y gestionar roles */}
            <Typography variant="body2" color="text.secondary">
                Consulta tu rol actual y gestiona tus funciones dentro de la plataforma.
            </Typography>
        </Box>
    );
} 